/** Canonical maximum width shared by standard and interactive tooltip surfaces. */
export const TOOLTIP_MAX_WIDTH_PX = 256

/** Canonical platform tooltip chrome, without positioning or content padding. */
export const TOOLTIP_SURFACE_CLASS =
  'w-fit max-w-[min(16rem,calc(100vw-2rem))] rounded-lg border border-[var(--border)] bg-[var(--bg)] text-[var(--text-body)] text-caption shadow-xs'
